<template>
    <div class="key-value-item">
        <div class="key-value-item__key">
            <slot name="key" />
        </div>
        <div class="key-value-item__value">
            <slot name="value" />
        </div>
    </div>
</template>

<style lang="scss">
.key-value-item {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 2.5cqw;
    border-radius: 0.5cqw;
    background: #fff;

    &__key {
        font-weight: 600;
        font-size: 3.5cqw;
    }

    &__value {
        font-size: 3.5cqw;
    }
}
</style>
